import MasterVideo from './master-video';

export default class MasterVideoDesktop extends MasterVideo {
	constructor(...args) {
		super(...args);
	}
	init(){
		super.init();

		this.dom.play = this.dom.component.querySelector(".play");
		this.dom.overlay = this.dom.component.querySelector(".overlay");
		this.dom.video = this.dom.component.querySelector(".video");
	}
	bind() {
		super.bind();

		this.dom.play.addEventListener("click", () => {
			// this.dom.overlay.style.opacity = "0";
			TweenLite.to(this.dom.overlay, 0.5, {
				autoAlpha: 0
			});
			this.dom.video.play();
		});

	}




	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/master-video/master-video.desktop.js